import { Controller as BaseController } from '@hotwired/stimulus';

export default class Controller extends BaseController {
  static values = {
    placeholder: { type: String, default: 'Escolha uma opção' },
    options: { type: Array, default: ['Sem opções'] },
    multiple: { type: Boolean, default: false },
    insideFilter: { type: Boolean, default: false },
    dropdownParent: { type: String, default: '' },
    action: { type: String, default: '' },
    searchable: { type: Boolean, default: false },
    clearable: { type: Boolean, default: false },
    ajaxUrl: { type: String, default: '' },
    loadOnType: { type: Boolean, default: false },
    selected: { type: Array, default: [] },
    modal: { type: Boolean, default: false },
    autosubmit: { type: Boolean, default: false },
    dropdownAbove: { type: Boolean, default: false },
    actionBox: { type: Boolean, default: false },
  };

  static targets = ['select', 'actionButton'];

  connect() {
    const closestDialog = this.element.closest('dialog');
    const optionsWithIcons = this.selectTarget.dataset.optionsWithIcons
      ? JSON.parse(this.selectTarget.dataset.optionsWithIcons)
      : null;
    const iconsOnly = this.element.dataset.iconsOnly === 'true';

    $(this.selectTarget).select2({
      placeholder: this.placeholderValue,
      multiple: this.multipleValue,
      ...(this.multipleValue && { closeOnSelect: false }), // Keep dropdown open for multiple selections
      ...(this.clearableValue && { allowClear: true }),
      ...(this.insideFilterValue && { dropdownParent: $('.filter-drawer') }),
      ...(this.dropdownParentValue !== '' && { dropdownParent: $(this.dropdownParentValue) }),
      ...(!this.searchableValue && { minimumResultsForSearch: -1 }),
      ...this.ajaxConfig(),
      ...(this.modalValue && { dropdownParent: closestDialog ? $(closestDialog) : $('body') }),
      ...(this.autosubmitValue && { tags: true }),
      ...(optionsWithIcons && {
        templateResult: (option) => {
          const iconOption = optionsWithIcons.find((item) => item.id == option.id);
          if (!iconOption || !iconOption.icon) return option.text;

          // No dropdown, sempre mostrar o ícone e o texto
          return $(`<span><i class="${iconOption.icon} tw-mr-2"></i>${option.text}</span>`);
        },
        templateSelection: (option) => {
          const iconOption = optionsWithIcons.find((item) => item.id == option.id);
          if (!iconOption || !iconOption.icon) return option.text;

          // No botão de seleção, mostrar apenas o ícone se iconsOnly for true
          if (iconsOnly) {
            return $(`<span><i class="${iconOption.icon}"></i></span>`);
          }
          return $(`<span><i class="${iconOption.icon} tw-mr-2"></i>${option.text}</span>`);
        },
      }),
    });
    if (this.dropdownAboveValue) {
      $(this.selectTarget).on('select2:open', () => {
        const dropdown = $('.select2-container--open .select2-dropdown');

        dropdown.removeAttr('style');

        dropdown.addClass('select2-dropdown--above');
      });
    }

    if (this.ajaxUrlValue !== '' && !this.loadOnTypeValue) {
      this.asyncSelectOptions();
    }

    if (this.multipleValue) {
      if (this.selectedValue.length > 0) {
        $(this.selectTarget).val(this.selectedValue).trigger('change');
      }
    }

    // Turbo bugs that duplicated elements
    const containerChildren =
      this.selectTarget.parentElement.getElementsByClassName('select2-container');
    if (containerChildren.length > 1) {
      containerChildren[1].remove();
    }

    if (this.actionValue !== '') {
      $(this.selectTarget).on('select2:select', () => {
        let event = new Event('change', { bubbles: true }); // fire a native event
        this.selectTarget.dispatchEvent(event);
      });
    }

    if (this.actionValue !== '') {
      $(this.selectTarget).on('select2:unselect', () => {
        let event = new Event('change', { bubbles: true }); // fire a native event
        this.selectTarget.dispatchEvent(event);
      });
    }

    if (this.autosubmitValue) {
      $(this.selectTarget).on('select2:select select2:unselect', () => {
        const form = this.element.closest('form');
        if (form) {
          form.requestSubmit();
        }
      });
    }

    // Update action button text based on selection state
    if (this.actionBoxValue && this.multipleValue) {
      $(this.selectTarget).on('select2:select select2:unselect', () => {
        this.updateActionButtonText();
      });
    }
  }

  disconnect() {
    if ($(this.selectTarget).data('select2')) {
      $(this.selectTarget).select2('destroy');
    }
  }

  checkValue() {
    this.selectTarget.on('select2:select', function () {
      const selectedBox = document.querySelector('.select2-selection--single');
      selectedBox.classList.add('select-box-answered');
    });
  }

  ajaxConfig() {
    if (this.ajaxUrlValue !== '' && this.loadOnTypeValue) {
      return {
        ajax: {
          url: this.ajaxUrlValue,
          dataType: 'json',
          delay: 250,
          data: (params) => {
            let data = {
              name: params.term,
            };

            // Adding search params to support filter by year in scheduled exams modal
            // This is a workaround maybe can bug some other page
            const searchParams = new URLSearchParams(window.location.search);
            for (let pair of searchParams.entries()) {
              data[pair[0]] = pair[1];
            }

            return data;
          },
          processResults: function (data) {
            return {
              results: data.map((item) => ({ id: item.id, text: item.name })),
            };
          },
          cache: true,
        },
      };
    }
  }

  asyncSelectOptions() {
    $.ajax({
      beforeSend: (xhr) => {
        xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'));
      },
      url: this.ajaxUrlValue,
      type: 'get',
      dataType: 'json',
      success: (data) => {
        $(this.selectTarget).empty(); // Clear existing options

        data.forEach((option) => {
          var newOption = new Option(option.name, option.id, false, false);
          $(this.selectTarget).append(newOption);
        });

        $(this.selectTarget).trigger('change');

        if (this.selectedValue.length > 0) {
          $(this.selectTarget).val(this.selectedValue).trigger('change');
        }
      },
    });
  }

  toggleSelectAll() {
    if (!this.multipleValue || !this.actionBoxValue) return;

    const $select = $(this.selectTarget);
    const allOptions = $select
      .find('option')
      .map(function () {
        return this.value;
      })
      .get();
    if (allOptions.length === 0) {
      return;
    }
    const selectedOptions = $select.val() || [];

    const areAllSelected = allOptions.length > 0 && selectedOptions.length === allOptions.length;

    if (areAllSelected) {
      // Deselect all
      $select.val(null).trigger('change');

      // Fire the same native event that Select2 would fire
      if (this.actionValue !== '') {
        let event = new Event('change', { bubbles: true });
        this.selectTarget.dispatchEvent(event);
      }

      if (this.hasActionButtonTarget) {
        this.actionButtonTarget.classList.remove('tw-bg-primary-300');
        this.actionButtonTarget.classList.add('tw-bg-gray-100');
      }
    } else {
      // Select all
      $select.val(allOptions).trigger('change');

      // Fire the same native event that Select2 would fire
      if (this.actionValue !== '') {
        let event = new Event('change', { bubbles: true });
        this.selectTarget.dispatchEvent(event);
      }

      if (this.hasActionButtonTarget) {
        this.actionButtonTarget.classList.remove('tw-bg-gray-100');
        this.actionButtonTarget.classList.add('tw-bg-primary-300');
      }
    }
  }

  updateActionButtonText() {
    if (!this.hasActionButtonTarget || !this.multipleValue || !this.actionBoxValue) return;

    const $select = $(this.selectTarget);
    const allOptions = $select
      .find('option')
      .map(function () {
        return this.value;
      })
      .get();
    const selectedOptions = $select.val() || [];

    const areAllSelected = allOptions.length > 0 && selectedOptions.length === allOptions.length;

    this.actionButtonTarget.textContent = areAllSelected ? 'Nenhuma' : 'Todas';
  }
}
